import { render, staticRenderFns } from "./ProjectAdd.vue?vue&type=template&id=5b9b38f5&"
import script from "./ProjectAdd.vue?vue&type=script&lang=js&"
export * from "./ProjectAdd.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports